import React from 'react';
import { Box, Loader } from '@wix/design-system';
import { Grid } from '../../components/grid';
import { AppBox } from '../../components/app-box';
import { withEssentialsContext } from '../../contexts/essentials-context';
import { VisibilityDetector } from '../visibility-detector';
import { v4 as generateUuidV4 } from 'uuid';
import { withSiteContext } from '../../contexts/site-context';
function AppGridComponent({ dataHook, apps, columns, minColumns, rows, isLoading, onAppClick, options, onAppLoad, getHref, showBorder, finalColumnsCount, languageCode = 'en', skin = 'default', }) {
    if (isLoading) {
        return (React.createElement(Box, { width: "100%", align: "center", padding: "48px" },
            React.createElement(Loader, { dataHook: "loader" })));
    }
    return (React.createElement(Grid, { dataHook: dataHook, columns: columns, rows: rows, minColumns: minColumns, finalColumnsCount: finalColumnsCount, skin: skin }, apps.map((app, index) => {
        const impressionId = generateUuidV4();
        return (React.createElement(VisibilityDetector, { onFirstVisible: () => {
                app && onAppLoad?.(app, index, impressionId);
            }, key: index },
            React.createElement(AppBox, { appData: app, options: {
                    showBadgesVertical: columns !== 1,
                    showBorder,
                    ...options,
                }, onClick: () => onAppClick?.(app, index, impressionId), href: getHref?.(app.slug, index), languageCode: languageCode, skin: skin })));
    })));
}
export const AppGrid = withSiteContext(withEssentialsContext(AppGridComponent));
//# sourceMappingURL=app-grid.js.map